const getDefaultState = (obj) => {
  for (let k in obj) {
    obj[k] = undefined;
  }
  return obj;
};

export default {
  state() {
    return JSON.parse(localStorage.getItem("user")) || { name: "" };
  },
  mutations: {
    /**
     * 登录成功
     *
     * @param {Object} state
     * @param {Object} user
     */
    SIGNIN(state, user) {
      localStorage.setItem("user", JSON.stringify(user));
      //   state.name = user.name;
      Object.assign(state, user);
    },
    /**
     * 退出登录
     *
     * @param {Object} state
     */
    SIGNOUT(state) {
      localStorage.removeItem("user");
      getDefaultState(state);
      // Object.keys(state).forEach(k => Vue.delete(state, k))
    },
    // saveMessage(state, user) {
    //     localStorage.setItem('user', JSON.stringify(user))
    //     Object.assign(state, user)
    // }
  },
  actions: {
    SIGNIN({ commit }, user) {
      commit("SIGNIN", user);
    },
    SIGNOUT({ commit }) {
      commit("SIGNOUT");
    },
    // saveMessage({ commit },user) {
    //     commit('saveMessage', user)
    // }
  },
};

// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

// const state = {
// 	user: {

// 	}
// }
// const state = JSON.parse(sessionStorage.getItem('user')) || {}

// const mutations = {
// 	/**
// 	 *登录成功
// 	 *
// 	 *@param {Object} state
// 	 *@param {Object} user
// 	**/
// 	SIGNIN(state, user) {
// 		sessionStorage.setItem('user', JSON.stringify(user))
// 		Object.assign(state, user)
// 	},

// 	*
// 	 *退出登录
// 	 *
// 	 *@param {Object} state
// 	 *@param {Object} user
// 	*
// 	SIGNOUT(state) {
// 		sessionStorage.removeItem('user')
//         Object.keys(state).forEach(k => Vue.delete(state, k))
// 	}

// }

// const actions = {
// 	SIGNIN({commit}, user) {
// 		commit('SIGNIN', user)
// 	},
// 	SIGNOUT({commit}) {
// 		commit('SIGNOUT')
// 	}
// }

// export default new Vuex.Store({
// 	state,
// 	mutations,
// 	actions
// })



// WEBPACK FOOTER //
// ./vuex/store.js